import type { ReactNode } from "react";

import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { useLocalizedNavigate } from "lib/i18n/navigation";

import { useSiteTranslations } from "./use-site-translations";

// The card on top of each "Мій сайт" page, like the admin's other pages; `backTo` adds "Назад".
export function SiteHeader({
  title,
  description,
  backTo,
  action,
  testId,
}: {
  title: ReactNode;
  description?: ReactNode;
  backTo?: string;
  action?: ReactNode;
  testId?: string;
}) {
  const navigate = useLocalizedNavigate();
  const { t } = useSiteTranslations();

  return (
    <Card data-testid={testId}>
      <SoftBox p={3}>
        {backTo ? (
          <SoftBox mb={1.5}>
            <SoftButton
              variant="text"
              color="info"
              size="small"
              data-testid="site-back-button"
              onClick={() => navigate(backTo)}
              sx={{ px: 0 }}
            >
              <Icon sx={{ mr: 0.5 }}>arrow_back</Icon>
              {t.back}
            </SoftButton>
          </SoftBox>
        ) : null}
        <SoftBox
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          gap={2}
        >
          <SoftBox lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              {title}
            </SoftTypography>
            {description ? (
              <SoftTypography variant="button" fontWeight="regular" color="text">
                {description}
              </SoftTypography>
            ) : null}
          </SoftBox>
          {action}
        </SoftBox>
      </SoftBox>
    </Card>
  );
}
